<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">Users</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">

            <div class="row">
              <div class="col-sm-12">
                <users-list ref="usersList" @openModal="openModal"/>
              </div>
            </div>
          </div>
            <!-- /.box-body -->
        </div>
      </div>
    </div>
    <new-user-modal @create="createUser" id="NewUserModal"></new-user-modal>
  </section>
</template>

<script>
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import api from '../../api'

export default {
  name: 'Cases',
  methods: {
    openModal () {
      window.jQuery('#NewUserModal').modal({})
    },
    createUser (user) {
      console.log(`create user : ${JSON.stringify(user)}`)
      api.authenticatedRequest('post', '/users', user)
      .then(response => {
        this.$refs.usersList.refresh(true)
      })
      .catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
<style>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'Font Awesome 5 Free';
}

.clickable {
    cursor: pointer;
}

table.dataTable thead .active:after {
    opacity: 0.5!important;
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
  opacity: 0.2;
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
  opacity: 0.2;
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
  opacity: 0.2;
}

.vertical-align-center {
  display: flex;
  align-items: center;
}

.new-btn {
  justify-content: center !important;
  margin: auto !important;
}

.search-btn:active:focus,
.new-btn:active:focus {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// Users.vue?d25a6af6